<script setup lang="ts">

import PromoTerms from "~/components/forms/PromoTerms.vue";

const locale = await getLocale("ui", "creditworthness");

</script>

<template>
 <PromoTerms
    :title="locale.title"
    :text="parseJsonUrls(locale.text)"
  />
</template>